<header class="flex justify-between items-center px-6 py-4 border-b border-gray-700">

    <ng-container *ngTemplateOutlet="headerRef()"></ng-container>

    <button
      class="text-gray-500 hover:text-gray-700 text-gray-300 hover:text-white focus:outline-none transition-colors duration-200"
      (click)="onClose()"
      aria-label="Close Dialog"
    >
      <i class="fa fa-times"></i>
    </button>
  </header>

  <section class="px-6 py-4 flex flex-col text-gray-700 text-gray-200 max-h-[800px]">
    <ng-container *ngTemplateOutlet="contentRef()"></ng-container>
  </section>




  <footer class=" bg-white flex justify-end items-center px-6 py-4 border-t border-gray-700 gap-4 h-[50px]">
    <ng-container *ngTemplateOutlet="footerRef()"></ng-container>
  </footer>
